import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../shared";

@Injectable()
export class DashboardService {
	constructor(private httpclientService: HttpclientService) {}

	StudentsOnSuspensionGetList(schoolID, PenaltyTypeID) {
		var postResult$ = new Subject();
		var url = "Dashboard/StudentsOnSuspensionGetList?SchoolID=" + schoolID + "&PenaltyTypeID=" + PenaltyTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentDashboardAttendanceGetList(schoolID) {
		var postResult$ = new Subject();
		var url = "Dashboard/StudentDashboardAttendanceGetList?schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ReleaseGetList(applicationID, schoolID, inDate) {
		var postResult$ = new Subject();
		var url = "Dashboard/ReleaseGetList?ApplicationID=" + applicationID + "&SchoolID=" + schoolID + "&InDate=" + inDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DashEventsGetList(applicationID, SchoolID, Date) {
		var postResult$ = new Subject();
		var url = "Dashboard/DashEventGetList?ApplicationID=" + applicationID + "&SchoolID=" + SchoolID + "&Date=" + Date;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	C9DashEventGetList(SchoolID, StartDate, EndDate, Active) {
		var postResult$ = new Subject();
		var url = "Dashboard/C9DashEventGetList?SchoolID=" + SchoolID + "&StartDate=" + StartDate + "&EndDate=" + EndDate + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
